module.exports = __webpack_public_path__ + "static/media/1pic.6d05fa80.png";